module.exports = __webpack_public_path__ + "img/image_q_8.webp";